export var PostType;
(function (PostType) {
    PostType["DISCUSSION"] = "DISCUSSION";
    PostType["QUESTION"] = "QUESTION";
})(PostType || (PostType = {}));
export var Interaction;
(function (Interaction) {
    Interaction["UNKNOWN"] = "UNKNOWN";
    Interaction["REACTION"] = "REACTION";
    Interaction["VOTE"] = "VOTE";
    Interaction["NONE"] = "NONE";
})(Interaction || (Interaction = {}));
export var EntityType;
(function (EntityType) {
    EntityType["UNKNOWN"] = "UNKNOWN";
    EntityType["COMMENT"] = "COMMENT";
    EntityType["REPLY"] = "REPLY";
})(EntityType || (EntityType = {}));
export var IdentityType;
(function (IdentityType) {
    IdentityType["UNKNOWN"] = "UNKNOWN";
    IdentityType["VISITOR"] = "VISITOR";
    IdentityType["MEMBER"] = "MEMBER";
})(IdentityType || (IdentityType = {}));
export var ReportType;
(function (ReportType) {
    ReportType["OFFENSIVE_CONTENT"] = "OFFENSIVE_CONTENT";
    ReportType["OFFENSIVE_MEDIA"] = "OFFENSIVE_MEDIA";
    ReportType["SPAM"] = "SPAM";
})(ReportType || (ReportType = {}));
export var PostFieldField;
(function (PostFieldField) {
    PostFieldField["UNKNOWN"] = "UNKNOWN";
    /** Includes Post content as a stringified DraftJS document (internal only). */
    PostFieldField["CONTENT"] = "CONTENT";
    /** Includes images from Post content (internal only). */
    PostFieldField["IMAGES"] = "IMAGES";
    /** Includes videos from Post content (internal only). */
    PostFieldField["VIDEOS"] = "VIDEOS";
    /** Includes Post URL. */
    PostFieldField["URL"] = "URL";
    /** Includes Post content as a stringified Rich Content document (internal only). */
    PostFieldField["RICH_CONTENT"] = "RICH_CONTENT";
})(PostFieldField || (PostFieldField = {}));
export var Field;
(function (Field) {
    Field["UNKNOWN"] = "UNKNOWN";
    /** Includes images from Post content. */
    Field["IMAGES"] = "IMAGES";
    /** Includes videos from Post content. */
    Field["VIDEOS"] = "VIDEOS";
    /** Post URL. */
    Field["URL"] = "URL";
    /** Includes reaction identities. */
    Field["REACTION_IDENTITIES"] = "REACTION_IDENTITIES";
})(Field || (Field = {}));
export var Order;
(function (Order) {
    Order["ASC"] = "ASC";
    Order["DESC"] = "DESC";
})(Order || (Order = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map